import { ApproversApproveMeta, ApproversApprovePayload } from 'types/store/ApproversApprove';
import { createAsyncReducer } from 'utils/Redux';

import { approversApproveActions } from '../actions';

export default createAsyncReducer<ApproversApproveMeta, ApproversApprovePayload>(approversApproveActions);
